import { createAction, props } from '@ngrx/store';

import { Feature } from '@vi-iot/client';

export namespace OperatingModesActions {
  export enum Type {
    READ_OR_LIST_FEATURES = '[OVERVIEW OPERATING MODE] Read Or List Features',
    LIST_FEATURES = '[OVERVIEW OPERATING MODE] List Features',
    LIST_FEATURES_SUCCESS = '[OVERVIEW OPERATING MODE] List Features Success',
    LIST_FEATURES_ERROR = '[OVERVIEW OPERATING MODE] List Features Error',
    LIVE_UPDATE_FEATURE = '[OVERVIEW OPERATING MODE] Live Update Feature',
  }

  export const readOrListFeatures = createAction(
    Type.READ_OR_LIST_FEATURES,
    props<{
      installationId: number;
      gatewaySerial: string;
      pairingId: string;
    }>()
  );

  export const listFeatures = createAction(
    Type.LIST_FEATURES,
    props<{
      installationId: number;
      gatewaySerial: string;
      pairingId: string;
    }>()
  );

  export const listFeaturesSuccess = createAction(
    Type.LIST_FEATURES_SUCCESS,
    props<{
      operatingModes: { circuits: string[]; mode: { [key: string]: Feature<unknown, unknown> } };
      gatewaySerial: string;
    }>()
  );

  export const listFeaturesError = createAction(Type.LIST_FEATURES_ERROR);

  export const liveUpdateFeature = createAction(
    Type.LIVE_UPDATE_FEATURE,
    props<{ featureName: string; feature: Feature<unknown, unknown>; gatewaySerial: string }>()
  );
}
